import styled from 'styled-components';

export const Backdrop = styled.div`
  // Fallback for browsers that do not support backdrop-filter.
  background: rgba(255, 255, 255, 0.75);
  height: 100%;
  width: 100%;

  // Blurred backdrop for supported browsers.
  // See: https://blog.logrocket.com/new-in-chrome-76/
  @supports ((-webkit-backdrop-filter: none) or (backdrop-filter: none)) {
    -webkit-backdrop-filter: blur(0.5rem);
    backdrop-filter: blur(0.5rem);
    background: rgba(255, 255, 255, 0.5);
  }
`;

export const Container = styled.div`
  height: 100vh;
  overflow: hidden;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 999;
`;

export const Content = styled.div`
  left: 50%;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);

  .ant-spin {
    padding-bottom: 2rem;
    width: 100vw;
  }

  .ant-spin-lg .ant-spin-dot {
    color: var(--color-primary__regular);
    font-size: 50px;
  }
`;

export const Text = styled.div`
  color: var(--color-neutral__title-active);
  cursor: default;
  font-size: 1.5rem;
  font-weight: 500;
  line-height: 1.2;
  outline: none;
  padding: 0 1rem;
  text-align: center;
`;
